import React from 'react'
import AdminPanel from "./components/AdminPanel"
const Admin = () => {
  return (
    <div>
      <AdminPanel />
    </div>
  );
}

export default Admin